import Axios from "axios";
import {config} from "@/config";

Axios.defaults.baseURL = config.apiUrl;
// Axios.defaults.headers.get['Auth-Token'] = '123';
Axios.defaults.headers.common['Content-Type'] = 'application/json';

export default {
    namespaced: true,
    state: {
        goods: [
        ],
        currentSort:'orderId',
        currentSortDir:'asc',
        pageSize:26,
        currentPage:1,
        countRow: 0,

        filterData: {},
        rangeFilterData: {},

        siteFilter: false,
        groupFilter: false,
        nameFilter: false,

        idFilter: false,

        idToFilter: false,
        fieldsList: []

    },
    getters: {
        FIELDS_LIST: state => {
            return state.fieldsList;
        },
        GOODS_LIST: state => {
            return state.goods;
        },
        FILTER_DATA: state => {
            return state.filterData;
        },
        RANGE_FILTER_DATA: state => {
            return state.rangeFilterData;
        },
        CURRENT_SORT: state => {
            return state.currentSort;
        },
        COUNT_ROW: state => {
            return state.countRow;
        },
        ID_FILTER: state => {
            return state.idFilter;
        },
        NAME_FILTER: state => {
            return state.nameFilter;
        },
        CURRENT_SORT_DIR: state => {
            return state.currentSortDir;
        },
        PAGE_SIZE: state => {
            return state.pageSize;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        SITE_FILTER: state => {
            return state.siteFilter;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.countRow/state.pageSize);
        }
    },
    mutations: {
        CURRENT_SORT: (state, payload) => {
            return state.currentSort = payload;
        },
        CURRENT_SORT_DIR: (state, payload) => {
            return state.currentSortDir = payload;
        },
        FIELDS_LIST: (state, payload) => {
            return state.fieldsList = payload;
        },
        FILTER_DATA: (state, payload) => {
            return state.filterData = payload;
        },
        RANGE_FILTER_DATA: (state, payload) => {
            return state.rangeFilterData = payload;
        },
        SET_GOODS: (state, payload) => {
            return state.goods = payload;
        },
        SET_COUNT_ROW: (state, payload) => {
            return state.countRow = payload;
        },
        PAGE_SIZE: (state, payload) => {
            return state.pageSize = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        }
    },
    actions: {
        GET_ALL: async ({state, commit}, payload) => {
            let params = {
                'page': state.currentPage,
                'pageSize': state.pageSize <= 0 ? 1 : state.pageSize,
                'filters': JSON.stringify(state.filterData),
                'rangeFilter': JSON.stringify(state.rangeFilterData),
                'sort': state.currentSort,
                'sortDir': state.currentSortDir
            };
            let createParamsUrl = function (params) {
                let urlParams = [];
                for (let prop in params) {
                    if (params[prop] !== false && params[prop] !== '') {
                        urlParams.push(prop +'='+ encodeURIComponent(params[prop]));
                    }
                }
                return '?'+ urlParams.join('&');
            }
            let urlParams = createParamsUrl(params);

            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/order' + urlParams,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SET_GOODS', responseData.data.list);
                    commit('SET_COUNT_ROW', responseData.data.count);
                    commit('FIELDS_LIST', responseData.data.fieldsList);
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
    }
}